import { GoogleOAuthProvider } from "@react-oauth/google";
import { useMemo } from "react";
import { ChatBubble } from "./ChatBubble/ChatBubble";
import { RadioPlayer } from "./RadioPlayer";
import { useChatStore } from "./store/chat";

function App() {
  const chatState = useChatStore();
  const hasChatCapability = useMemo(
    () =>
      true ||
      document.location.hostname === "localhost" ||
      new URLSearchParams(document.location.search).has("hasChat"),
    []
  );
  return (
    <>
      <GoogleOAuthProvider
        onScriptLoadSuccess={() => {
          window.dispatchEvent(new Event("googleLoaded"));
        }}
        clientId="699222484967-qpr857q72t4vnl13bg7d7t28pcgcmmcu.apps.googleusercontent.com">
        <div className="sc-radio-player-h">
          {chatState.visible && <ChatBubble />}
          <RadioPlayer hasChat={hasChatCapability} />
        </div>
      </GoogleOAuthProvider>
    </>
  );
}

export default App;
